import React from 'react';
import {CHALLENGE_DISPLAY} from '../../../../shared/constants/ChallengeTypes';
import {trimProgress} from '../../../../shared/utils/ChallengeHelpers';
import {
  capitalizeFirstLetter,
  getPercentage,
  ordinalIndicator,
} from '../../../../shared/utils/Helpers';
import styles from './ChallengeCard.module.css';

const ChallengeProgressBar = ({
  progress,
  place,
  goal,
  metric,
  challengeEnd,
}) => {
  return (
    <>
      <div className={styles.barContainer}>
        <div
          className={styles.barContainer}
          style={{
            backgroundColor: 'var(--secondary)',
            width: getPercentage(progress, goal),
          }}>
          {parseFloat(progress) >= parseFloat(goal) && (
            <p className={styles.percentageText}>✓</p>
          )}
        </div>
      </div>
      <div className={styles.bottomContainer}>
        <p className="namesAndObjects">
          {parseFloat(progress) >= parseFloat(goal)
            ? trimProgress(progress, metric)
            : `${trimProgress(progress || 0, metric)}/${trimProgress(
                goal,
                metric,
              )}`}
          {` ${CHALLENGE_DISPLAY[metric]}`}
        </p>
        <p className="namesAndObjects">
          {challengeEnd
            ? challengeEnd
            : place
            ? ' ' + ordinalIndicator(place) + ' Place'
            : null}
        </p>
      </div>
    </>
  );
};

export default ChallengeProgressBar;
